import { camelCase, mapKeys, mapValues, snakeCase } from 'lodash';

const convertCase = (
  object: Record<string, unknown> | unknown,
  converter: (stringToConvert: string | undefined) => string
): Record<string, unknown> | unknown => {
  if (!object) return object;

  if (Array.isArray(object)) {
    return object.map((value) => convertCase(value, converter));
  }

  if (typeof object === 'object') {
    const newObject = mapKeys(object, (_value: unknown, key: string) => converter(key));
    return mapValues(newObject, (value) => convertCase(value, converter));
  }

  return object;
};

export const snakeToCamel = (
  object: Record<string, unknown> | unknown
): Record<string, unknown> | unknown => convertCase(object, camelCase);

export const camelToSnake = (
  object: Record<string, unknown> | unknown
): Record<string, unknown> | unknown => convertCase(object, snakeCase);

export const numbersIn = (word: string): string => (word.match(/(\d+)/g) || [''])[0];

export const lastNChars = (n: number, word: string): string => word.slice(-n);

export const isSingleDigit = (value: string): boolean => /^\d$/.test(value);
